/**
 * Manage API — the platform's view of the API: what it serves, who holds
 * credentials for it, and the reference.
 *
 * WAS "Developer Tools" until 2026-08-30 (Ben). The name moved to the CLUB
 * screen, which is the one a customer's engineer opens; this is the
 * cross-club operations view and "Manage API" says so, matching Manage Clubs
 * and Manage Games beside it in the rail.
 *
 * It absorbs /manage-api-tokens rather than linking to it: "which routes does
 * this build serve" and "who can call them" are the same question asked twice.
 *
 * Staff only, enforced server-side — every endpoint behind these tabs answers
 * 404 to a non-staff caller whether or not the rail drew the link.
 */
import ApiReference from '../components/api/ApiReference'
import TabStrip from '../components/api/TabStrip'
import ApiRoutes from './ApiRoutes'
import ManageApiTokens from './ManageApiTokens'
import type { Session } from '../lib/api'
import './admin.css'

export default function ManageApi({ session }: { session: Session }) {
  return (
    <>
      <h1 className="page-title">Manage API</h1>
      <p className="page-sub">
        What this build serves, who holds credentials for it, and the reference
        a club’s engineer reads.
      </p>
      <TabStrip label="Manage API sections" tabs={[
        { id: 'routes', label: 'Routes and tests', body: () => <ApiRoutes /> },
        { id: 'tokens', label: 'Tokens', body: () => <ManageApiTokens session={session} /> },
        { id: 'reference', label: 'Documentation',
          body: () => <ApiReference scope="platform" /> },
      ]} />
    </>
  )
}
